import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import {
  UnarchiveCustomEventRequestBodyType,
  UnarchiveCustomEventResponseBodyType,
} from "@intelligems/ig-types";
import { combinedCustomEventsKeys, customEventsKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { setUnarchivingEventId } from "@src/store/slices/customEvents";
import { setIgnoreUpdateDetected } from "@src/store/slices/global";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const unarchiveCustomEvent = async (
  data: ApiRequest<UnarchiveCustomEventRequestBodyType>
): Promise<UnarchiveCustomEventResponseBodyType> => {
  const resp = await api.patch<UnarchiveCustomEventResponseBodyType>(
    `/v2/custom-events/${data.body.customEventId}/unarchive`,
    { customEventId: data.body.customEventId }
  );
  return resp.data;
};

export const useUnarchiveCustomEvent = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ["unarchiveCustomEvent"],
    mutationFn: async (data: ApiRequest<UnarchiveCustomEventRequestBodyType>) =>
      unarchiveCustomEvent(data),
    onMutate: () => {
      dispatch(setIgnoreUpdateDetected(true));
    },
    onSuccess: async (data, payload) => {
      await queryClient.invalidateQueries({
        queryKey: combinedCustomEventsKeys.all,
      });
      void queryClient.invalidateQueries({
        queryKey: customEventsKeys.all,
      });
      dispatch(setUnarchivingEventId({ id: "" }));
      toast.success(`${data.customEvent.name} Unarchived`);
    },
  });
};
